import iconMixin from '../../mixins/iconMixin'

export default {
  mixins: [iconMixin],
  data: function () {
    return {
      viewBox: "0 0 24 24",
      rawSvgPath: '<path d="M6,2C4.89,2,4,2.9,4,4v16c0,1.104,0.896,2,2,2h12c1.104,0,2-0.896,2-2V8l-6-6 M13,3.5L18.5,9H13 M18,12.93\n' +
        '\tV20h-7.07l2.12-2.12l-2.83-2.83l2.83-2.83l2.82,2.83"/>',
    }
  },
}